/**
 * Shared GPA computation helpers.
 * Weights: tests average = 20%, midterm = 30%, final = 50%.
 */

/**
 * Compute a skill's weighted GPA from its component scores (all plain numbers or null).
 * Returns the weighted average (0–10), or null if no scores are present.
 */
export function computeSkillGPA(tests, midterm, final) {
    let sum = 0, weight = 0;
    const avgTests = tests.length > 0 ? tests.reduce((a, b) => a + b, 0) / tests.length : null;
    if (avgTests !== null) { sum += avgTests * 0.20; weight += 0.20; }
    if (midterm !== null)  { sum += midterm  * 0.30; weight += 0.30; }
    if (final !== null)    { sum += final    * 0.50; weight += 0.50; }
    return weight > 0 ? sum / weight : null;
}

/**
 * Compute the overall GPA for a raw score array from the API
 * (array of { subject: { subject_code }, score_type, score } objects).
 * Returns a number 0–10.
 */
export function computeGPA(scoreArray) {
    const skillMap = {};
    scoreArray.forEach(el => {
        const code = el.subject?.subject_code || 'X';
        if (!skillMap[code]) skillMap[code] = { tests: [], midterm: null, final: null };
        const st = el.score_type || 'final';
        if (st === 'midterm')     skillMap[code].midterm = el.score;
        else if (st === 'final')  skillMap[code].final   = el.score;
        else                      skillMap[code].tests.push(el.score);
    });
    let total = 0, count = 0;
    Object.values(skillMap).forEach(skill => {
        const gpa = computeSkillGPA(skill.tests, skill.midterm, skill.final);
        if (gpa !== null) { total += gpa; count++; }
    });
    return count > 0 ? total / count : 0;
}
